export default __webpack_public_path__ + "static/media/hotDrink3.7ad6741f.jpg";